import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdSavedReportsSuspense } from "api/generated/users/users";

export function useSavedReportsForUserQuery(userId: number) {
    return useGetUsersUserIdSavedReportsSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
